package com.ilussobsa.views

import com.ilussobsa.Resources
import com.ilussobsa.utils.defaultAppTheme
import com.ilussobsa.utils.ilussoFullLogo
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*

fun ViewWriter.nothingSelected(message: String) = frame {
    centered - col {
        expanding - space()
        centered - text(message)
        expanding - space()
        centered - image {
            ::source { Resources.ilussoFullLogo(defaultAppTheme) }
            opacity = 0.25
            this.description = ""
        }
        weight(3f) - space()
    }
}